/**
 * Accessibility Fix: perweb–AMP34 - Correct focus order for Instant Search dropdown
 * Target Order: Search Input -> Products -> Popular Suggestions
 */


document.addEventListener("DOMContentLoaded", function() {
    // We observe the body because the search dropdown is injected dynamically
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                
                // 1. Identify the Products container
                const productList = document.querySelector('.boost-sd__instant-search-product-list');
                
                // 2. Identify the Suggestions container
                // Note: Verify this class matches your specific Boost version in DevTools
                const suggestionList = document.querySelector('.boost-sd__instant-search-suggestion-wrapper') 
                                    || document.querySelector('.boost-sd__instant-search-column-suggestion');

                if (productList && suggestionList) {
                    const parent = productList.parentNode;

                    // Ensure both elements share the same parent container
                    if (suggestionList.parentNode === parent) {
                        
                        // Check if Suggestions come BEFORE Products in the DOM
                        // Node.DOCUMENT_POSITION_FOLLOWING (4) means productList is after suggestionList
                        if (suggestionList.compareDocumentPosition(productList) & Node.DOCUMENT_POSITION_FOLLOWING) {
                            
                            // Move the Products container BEFORE the Suggestions container
                            parent.insertBefore(productList, suggestionList);
                        }
                    }
                }
            }
        }
    });

    // Start observing the document
    observer.observe(document.body, { childList: true, subtree: true });
});



/**
 * ADA Compliance Fix: Shop pay SVG alt and aria-label definition
 * Targets: .shopify-payment-button__button--shop-pay
 */


(function() {
    const applyAccessibilityFixes = () => {
      // 1. Target the Shop Pay Button
      const shopPayButton = document.querySelector('.shopify-payment-button__button--shop-pay');
      if (shopPayButton) {
        shopPayButton.setAttribute('aria-label', 'Pay with Shop Pay');
        
        // Ensure SVGs inside are accessible
        const shopPaySvgs = shopPayButton.querySelectorAll('svg');
        shopPaySvgs.forEach(svg => {
          if (!svg.getAttribute('aria-label')) {
            svg.setAttribute('role', 'img');
            svg.setAttribute('aria-label', 'Shop Pay Logo');
          }
        });
      }

      // 2. Target your specific purple icon/element
      // This looks for any element with BOTH classes
      const purpleIcons = document.querySelectorAll('.size-8.text-purple-primary');
      purpleIcons.forEach(icon => {
        // We only add the label if it doesn't already have one
        if (!icon.hasAttribute('aria-label')) {
          icon.setAttribute('aria-label', 'Icon description'); 
          // Note: Change 'Icon description' to whatever the icon actually represents (e.g., "Size Guide")
          
          // If it's an SVG, make sure it's not hidden from screen readers
          if (icon.tagName.toLowerCase() === 'svg') {
            icon.setAttribute('role', 'img');
            icon.setAttribute('aria-hidden', 'false');
          }
        }
      });
    };

    // Initialize the observer to catch elements as they load
    const observer = new MutationObserver((mutations) => {
      applyAccessibilityFixes();
    });

    // Start observing
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    // Run once on initial load just in case elements are already there
    applyAccessibilityFixes();
  })();


/**
 * ADA Compliance Fix: Convert Tooltip Divs to Buttons & Add Aria-Labels
 * Targets: .boost-sd__tooltip-content
 */

(function() {
  const upgradeBoostTooltips = () => {
    const tooltipDivs = document.querySelectorAll('.boost-sd__tooltip-content:not([data-ada-fixed])');

    tooltipDivs.forEach((oldDiv) => {
      // 1. Create the new Button element
      const newButton = document.createElement('button');
      
      // 2. Copy all classes and existing attributes
      newButton.className = oldDiv.className;
      Array.from(oldDiv.attributes).forEach(attr => {
        newButton.setAttribute(attr.name, attr.value);
      });

      // 3. Set ADA specific attributes
      const tooltipText = oldDiv.innerText.trim() || "Change layout";
      newButton.setAttribute('aria-label', tooltipText);
      newButton.setAttribute('type', 'button'); // Prevent form submission
      newButton.setAttribute('data-ada-fixed', 'true'); // Prevent infinite loop

      // 4. Move the internal content (icons/text) to the new button
      while (oldDiv.firstChild) {
        newButton.appendChild(oldDiv.firstChild);
      }

      // 5. Swap the elements in the DOM
      if (oldDiv.parentNode) {
        oldDiv.parentNode.replaceChild(newButton, oldDiv);
      }
    });
  };

  // Run on Boost initial render
  window.addEventListener('boost-sd-rendered', upgradeBoostTooltips);

  // Use MutationObserver for tooltips that are dynamically injected on hover/interaction
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.classList?.contains('boost-sd__tooltip-content') || node.querySelector?.('.boost-sd__tooltip-content'))) {
            shouldRun = true;
          }
        });
      }
    });
    if (shouldRun) upgradeBoostTooltips();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Initial execution for static elements
  upgradeBoostTooltips();
})();




/**
 * ADA Fix: Manage Focus & ARIA Live Announcements for Boost Pagination
 * Resolves WCAG 2.4.3 (Focus Order) and WCAG 4.1.2 (Name, Role, Value)
 */
(function() {
    let isPaginationClicked = false;
    let announcementText = "New products loaded."; // Default fallback text

    // 1. Create a visually hidden ARIA live region for screen reader announcements
    const createLiveRegion = () => {
        let liveRegion = document.getElementById('boost-ada-announcer');
        if (!liveRegion) {
            liveRegion = document.createElement('div');
            liveRegion.id = 'boost-ada-announcer';
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            
            // Standard CSS to visually hide the element while keeping it accessible
            Object.assign(liveRegion.style, {
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: '0',
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                border: '0'
            });
            document.body.appendChild(liveRegion);
        }
        return liveRegion;
    };

    const liveRegion = createLiveRegion();

    // 2. Intercept clicks to determine if the user interacted with pagination
    document.addEventListener('click', function(event) {
        // Target the specific button clicked within the pagination container
        const paginationButton = event.target.closest('button.boost-sd__pagination-number, a.boost-sd__pagination-number, .boost-sd__pagination-button');
        const paginationContainer = event.target.closest('.boost-sd__pagination');
        
        if (paginationContainer && paginationButton) {
            isPaginationClicked = true;
            
            // Attempt to grab the page number (e.g., "2", "3") for a better announcement
            const pageText = paginationButton.textContent.trim();
            if (pageText && !isNaN(pageText)) {
                announcementText = `Page ${pageText} loaded.`;
            } else {
                // Fallback for "Next" or "Load More" buttons
                announcementText = "New page of products loaded.";
            }
        } else if (event.target.closest('.boost-sd__filter-block')) {
            // Do not hijack focus/announcements if they are just clicking filters
            isPaginationClicked = false;
        }
    }, true);

    // 3. Observe the product grid for DOM updates
    const initializeADAObserver = function() {
        const gridContainer = document.querySelector('.boost-sd__product-list');
        
        if (!gridContainer) {
            setTimeout(initializeADAObserver, 500);
            return;
        }

        const observer = new MutationObserver(function(mutations) {
            if (isPaginationClicked) {
                const hasNewNodes = mutations.some(mutation => mutation.addedNodes.length > 0);
                
                if (hasNewNodes) {
                    setTimeout(() => {
                        // A. Trigger the screen reader announcement
                        // Briefly clearing the text ensures the screen reader registers it as a "change" even if clicking the same button
                        liveRegion.textContent = ''; 
                        setTimeout(() => { liveRegion.textContent = announcementText; }, 50);

                        // B. Manage keyboard focus
                        const firstProduct = gridContainer.querySelector('.boost-sd__product-item');
                        if (firstProduct) {
                            firstProduct.setAttribute('tabindex', '-1');
                            firstProduct.focus();
                            firstProduct.style.outline = 'none'; 
                        }
                        
                        // C. Reset the flag
                        isPaginationClicked = false; 
                    }, 100); 
                }
            }
        });

        observer.observe(gridContainer, { childList: true, subtree: false });
    };

    // 4. Start the observer
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeADAObserver);
    } else {
        initializeADAObserver();
    }
})();